<div class="app-titulo-pagina-v2">
    <img src="../../../assets/img/icons/bt_sac.png" alt="Icone btn_sac">
    <span>SAC - Detalhes</span>
</div>
<h3>
    <strong>Protocolo: </strong>{{ mainService.sacService.chamadoSelecionado?.dataRegistro| dateFormat:'':'yyyy' }}
    {{'-'+ mainService.sacService.chamadoSelecionado?.id}}
</h3>

<h3 id="titulo-status">
    <strong>Status: </strong>{{ mainService.sacService.chamadoSelecionado?.status| uppercase }}
</h3>

<h3>
    <strong>Assunto: </strong>{{ mainService.sacService.chamadoSelecionado?.assunto }}
</h3>

<div *ngIf="mainService.sacService.processando" class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div *ngFor="let mensagem of mainService.sacService.chamadoSelecionado.mensagens"
    [ngClass]="{'alert alert-info': mainService.sacService.chamadoSelecionado.cartao.id === mensagem.usuario.id, 'alert alert-success': mainService.sacService.chamadoSelecionado.cartao.id !== mensagem.usuario.id}"
    role="alert" style="padding: 15px; margin-bottom: 20px">
    <p>
        {{ mensagem.usuario.nome }}<br>
        <small>{{ mensagem.dataRegistro| dateFormat:'dd/MM/yyyy HH:mm' }}</small>
    </p>
    <pre class="text-left" id="mensagem-sac">{{ mensagem.mensagem }}</pre>
</div>
<a (click)="mainService.loginService.changeRoute('sac')" id="btn-voltar" class="btn btn-danger-v2">
    Voltar
</a>
<button *ngIf="mainService.sacService.chamadoSelecionado.status !== 'solucionado'" type="button" class="btn app-btn-best"
    data-toggle="modal" data-target="#mensagem">Adicionar Mensagem
</button>
<button *ngIf="mainService.sacService.chamadoSelecionado.status !== 'solucionado'"
    (click)="mainService.sacService.visualizarAnexos(mainService.sacService.chamadoSelecionado)" class="btn app-btn-best">
    <i class="fa fa-paperclip"></i> Anexos
</button>
<button id="finalizarChamado" *ngIf="mainService.sacService.chamadoSelecionado.status !== 'solucionado'"
    class="btn btn-warning" data-toggle="modal"
    [attr.data-target]="mainService.sacService.chamadoSelecionado.status !== 'concluido' ? '#naoFinalizar' : '#avaliacao'">Finalizar
    Chamado
</button>

<div class="modal" id="mensagem" tabindex="-1" role="dialog" aria-labelledby="mensagemLabel" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close" data-dismiss="modal" aria-label="Fechar">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="mensagemLabel">Mensagem</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="mensagem">Mensagem</label>
                    <textarea class="form-control" id="mensagem" rows="8" name="mensagem" required
                        [(ngModel)]="mensagem.mensagem">
                        </textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success-v2" (click)="saveMensagem()" id="btn-modal-salvar"
                    data-dismiss="modal">
                    Salvar
                </button>
                <button class="btn btn-default" data-dismiss="modal" id="btn-modal-fechar">Fechar</button>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="naoFinalizar" tabindex="-1" role="dialog" aria-labelledby="naoFinalizarLabel"
    data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close" data-dismiss="modal" aria-label="Fechar">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="avaliacaoLabel">Atenção</h4>
            </div>
            <div class="modal-body">
                <p>O seu chamado esta sendo analisado pela nossa equipe. Caso o problema já tenha sido resolvido,
                    adicione uma mensagem a ele nos informando a resolução.</p>
            </div>
            <div class="modal-footer">
                <button class="btn app-btn-best" data-dismiss="modal" id="btn-modal-cancelar">Ok</button>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="avaliacao" tabindex="-1" role="dialog" aria-labelledby="avaliacaoLabel" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close" data-dismiss="modal" aria-label="Fechar">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="avaliacaoLabel">Atribua uma nota</h4>
            </div>
            <div class="modal-body">
                <p>Por favor atribua uma nota ao atendimento de 1 a 5, sendo 1
                    Muito insatifeito e 5 Muito satisfeito</p>
                <div class="radio">
                    <label><input type="radio" name="nota" [value]="5"
                            [(ngModel)]="mainService.sacService.chamadoSelecionado.nota">Muito satisfeito</label>
                </div>
                <div class="radio">
                    <label><input type="radio" name="nota" [value]="4"
                            [(ngModel)]="mainService.sacService.chamadoSelecionado.nota">Satisfeito</label>
                </div>
                <div class="radio">
                    <label><input id="regular" type="radio" name="nota" [value]="3"
                            [(ngModel)]="mainService.sacService.chamadoSelecionado.nota">Regular</label>
                </div>
                <div class="radio">
                    <label><input type="radio" name="nota" [value]="2"
                            [(ngModel)]="mainService.sacService.chamadoSelecionado.nota">Insatisfeito</label>
                </div>
                <div class="radio">
                    <label><input type="radio" name="nota" [value]="1"
                            [(ngModel)]="mainService.sacService.chamadoSelecionado.nota">Muito insatisfeito</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn app-btn-best" (click)="finalizeChamado()" id="btn-modal-finalizar"
                    data-dismiss="modal" [disabled]="!mainService.sacService.chamadoSelecionado.nota">
                    Finalizar</button>
                <button class="btn btn-default" data-dismiss="modal" id="btn-modal-cancelar">Cancelar</button>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/detalhe/detalhe.component.html